import { ApolloClient, gql, NormalizedCacheObject, useQuery } from '@apollo/client'
import { CategoriesQuery, CategoriesQueryVariables } from 'types/graphql'

export const getCategoriesQuery = gql`
  query Categories($onlyRoots: Boolean, $parentIds: [Int!]) {
    categories(onlyRoots: $onlyRoots, parentIds: $parentIds) {
      id
      name
      description
      metaDescription
      slug
      parent {
        id
        name
        slug
      }
      children {
        id
        name
        slug
      }
    }
  }
`

export const queryCategoriesWithClient = (apolloClient: ApolloClient<NormalizedCacheObject>, variables: CategoriesQueryVariables) =>
  apolloClient.query<CategoriesQuery, CategoriesQueryVariables>({ query: getCategoriesQuery, variables })

export const useCategories = (variables?: CategoriesQueryVariables) => {
  return useQuery<CategoriesQuery, CategoriesQueryVariables>(getCategoriesQuery, { variables })
}
